<template>
		<div class="card-base about-us d-flex flex-row rounded-3">
			<seo-image :data="data.img_path" :class="'about-us-img'" :alt="data.name" />
			<div class="about-us-content">
				<div>
					<h5 class="about-us-name">{{ data.name }}</h5>
					<p class="about-us-post">{{ data.post }}</p>
				</div>
				<div class="about-us-body">
					<p class="about-us-text">{{ data.body }}</p>
				</div>
			</div>
		</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {AboutUsInterface} from "../Interfaces/AboutUsInterface";
import SeoImage from "../SeoImage.vue";

export default defineComponent({
	name: 'AboutUsCard',
	components: {SeoImage},
	props: {
		data: {
			type: Object as PropType<AboutUsInterface>,
			required: true
		}
	},
});
</script>

<style lang="scss" scoped>

</style>
